<template>
  <div class="app-download-buttons-fi">
    <template v-for="button in buttons">
      <div
        v-if="!isEditMode && ((button.img && button.link) || inlineEditMode)"
        :key="button.id"
        class="app-download-buttons-fi__button"
      >
        <link-field-fi :field-name="button.fieldNameLink">
          <img
            v-if="button.img?.src"
            class="app-download-buttons-fi__image"
            :src="button.img.src"
            :alt="button.img.alt"
          />
          <div
            v-else-if="inlineEditMode"
            class="fi-p-24"
          >
            &nbsp;
          </div>
        </link-field-fi>
        <div v-if="inlineEditMode && button.img">
          <div>edit image:</div>
          <div><cloud-image-fi :field-name="button.fieldName" /></div>
        </div>
      </div>
      <div
        v-if="isEditMode"
        :key="button.id"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="fi-mb-9"
          v-html="button.imgEdit"
        />
        <div v-html="button.linkEdit" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { CloudImageFi, LinkFieldFi } from 'atoms';
import { computed } from 'vue';

import { useInlineEdit } from '@/composables/inlineEdit';
import type { AppDownloadTeaserFiFields } from '@/generated/fields';

defineOptions({
  name: 'AppDownloadButtonsFi',
});

const props = defineProps<{
  fields: AppDownloadTeaserFiFields;
}>();

const { inlineEditMode } = useInlineEdit();

const buttonLeft = computed(() =>
  props.fields.buttonLeft?.value?.src ? props.fields.buttonLeft.value : null,
);

const buttonLeftLink = computed(() => {
  const val = props.fields.buttonLeftLink?.value;
  return val && (val.url || val.href) ? val : null;
});

const buttonRight = computed(() =>
  props.fields.buttonRight?.value?.src ? props.fields.buttonRight.value : null,
);

const buttonRightLink = computed(() => {
  const val = props.fields.buttonRightLink?.value;
  return val && (val.url || val.href) ? val : null;
});

const buttons = computed(() => [
  {
    id: 'button-left',
    img: buttonLeft.value,
    imgEdit: props.fields.buttonLeft?.editable,
    link: buttonLeftLink.value,
    linkEdit: props.fields.buttonLeftLink?.editable,
    fieldNameLink: 'buttonLeftLink',
    fieldName: 'buttonLeft',
  },
  {
    id: 'button-right',
    img: buttonRight.value,
    imgEdit: props.fields.buttonRight?.editable,
    link: buttonRightLink.value,
    linkEdit: props.fields.buttonRightLink?.editable,
    fieldNameLink: 'buttonRightLink',
    fieldName: 'buttonRight',
  },
]);
</script>

<style scoped src="./app-download-buttons-fi" />
